import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICategory, ICategoryFormValues } from "../entities/category.entity";
import { CategorySaveChanges, initialState } from "./categories.state";

export const CategoriesSlice = createSlice({
    name: "categories",
    initialState,
    reducers: {
        setCategories: (state, action: PayloadAction<ICategory[]>) => {
            state.data.categories = action.payload;
        },
        setCategoriesLoading: (state, action: PayloadAction<boolean>) => {
            state.ui.loading = action.payload;
        },
        setCategoriesLoadingDelete: (state, action: PayloadAction<boolean>) => {
            state.ui.loadingDelete = action.payload;
        },
        setCategoryBackup: (state, action: PayloadAction<ICategoryFormValues>) => {
            state.data.categoryBackup = action.payload;
        },
        setCategorySaveChanges: (state, action: PayloadAction<CategorySaveChanges>) => {
            state.data.saveChanges = action.payload;
        },
    },
});

export const categoriesActions = CategoriesSlice.actions;
export const categoriesReducer = CategoriesSlice.reducer;